import React, { useEffect } from 'react'
import Header from '../../components/layout/Header'
import Sidebar from '../../components/layout/Sidebar'

import CreateAppointment from '../../components/appointment/CreateAppointment'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import ProdCalculation from '../../components/appSettings/ProCalculation'

const ProductionCalculation = ({ nav }) => {

    const navigate = useNavigate()

    const userLogin = useSelector(state => state.userSignIn)
    const { error, userInfo } = userLogin

    useEffect(() => {
        if (!userInfo) {
            navigate('/sign-in')
        }
        window.scrollTo(0, 0)
    }, [userInfo, navigate])

    return (
        <>
            <div className={nav.isSidebar}>
                <Header nav={nav} />
                <Sidebar nav={nav} />
                {/*start content*/}
                <main className="page-content">
                    {/*breadcrumb*/}
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/">
                                            <i className="bx bx-home-alt" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Settings
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Production calculation
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    {/*end breadcrumb*/}
                    <ProdCalculation />
                    {/*end row*/}
                </main>

                <div className="overlay nav-toggle-icon" />
                <a href="" className="back-to-top">
                    <i className="bx bxs-up-arrow-alt" />
                </a>
            </div>
        </>
    )
}

export default ProductionCalculation